// import React, { useState } from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TablePagination,
//   IconButton,
//   Tooltip,
// } from '@mui/material';
// import { 
//   Edit,
//   Visibility,
//   Delete,
//   Assignment
// } from '@mui/icons-material';
// import { useHistory } from 'react-router-dom'; // <-- Importar useHistory
// const TEncuestas = ({ rows, termp }) => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const history = useHistory(); // <-- Inicializar history
//   // Filtrar encuestas basado en el término de búsqueda
//   const encuestasFiltradas = rows.filter((encuesta) => {
//     if (!termp) return true;
    
//     const searchTerm = termp.toLowerCase();
//     return (
//       encuesta.titulo?.toLowerCase().includes(searchTerm) ||
//       encuesta.descripcion?.toLowerCase().includes(searchTerm) ||
//       encuesta.numEncuesta?.toLowerCase().includes(searchTerm)
//     );
//   });

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const formatearFecha = (fecha) => {
//     if (!fecha) return '';
//     const date = new Date(fecha);
//     return date.toLocaleDateString('es-ES', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit'
//     });
//   };

//   const handleVerEncuesta = (encuestaId) => {
//     console.log('Ver encuesta:', encuestaId);
//     history.push(`/ver-encuesta/${encuestaId}`);
//   };

//   const handleEditarEncuesta = (encuestaId) => {
//     console.log('Editar encuesta:', encuestaId);
//     // Implementar navegación a edición de encuesta
//   };

//   const handleEliminarEncuesta = (encuestaId) => {
//     console.log('Eliminar encuesta:', encuestaId);
//     // Implementar eliminación de encuesta
//   };

//   const handleGestionarRespuestas = (encuestaId) => {
//     console.log('Gestionar respuestas:', encuestaId);
//     // Implementar navegación a respuestas de encuesta
//   };

//   return (
//     <Paper>
//       <TableContainer>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell><strong>Código Encuesta</strong></TableCell>
//               <TableCell><strong>Título</strong></TableCell>
//               <TableCell><strong>Descripción</strong></TableCell>
//               <TableCell><strong>Fecha Creación</strong></TableCell>
//               <TableCell><strong>Preguntas</strong></TableCell>
//               <TableCell><strong>Acciones</strong></TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {encuestasFiltradas
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((encuesta) => (
//                 <TableRow key={encuesta.encuestaId}>
//                   <TableCell>{encuesta.numEncuesta}</TableCell>
//                   <TableCell>{encuesta.titulo}</TableCell>
//                   <TableCell>
//                     {encuesta.descripcion && encuesta.descripcion.length > 50
//                       ? `${encuesta.descripcion.substring(0, 50)}...`
//                       : encuesta.descripcion}
//                   </TableCell>
//                   <TableCell>{formatearFecha(encuesta.fechaCreacion)}</TableCell>
//                   <TableCell align="center">{encuesta.cantidadPreguntas}</TableCell>
//                   <TableCell>
//                     <Tooltip title="Ver encuesta">
//                       <IconButton
//                         color="primary"
//                         onClick={() => handleVerEncuesta(encuesta.encuestaId)}
//                       >
//                         <Visibility />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Editar encuesta">
//                       <IconButton
//                         color="default"
//                         onClick={() => handleEditarEncuesta(encuesta.encuestaId)}
//                       >
//                         <Edit />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Gestionar respuestas">
//                       <IconButton
//                         color="secondary"
//                         onClick={() => handleGestionarRespuestas(encuesta.encuestaId)}
//                       >
//                         <Assignment />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Eliminar encuesta">
//                       <IconButton
//                         style={{ color: '#f44336' }}
//                         onClick={() => handleEliminarEncuesta(encuesta.encuestaId)}
//                       >
//                         <Delete />
//                       </IconButton>
//                     </Tooltip>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             {encuestasFiltradas.length === 0 && (
//               <TableRow>
//                 <TableCell colSpan={6} align="center">
//                   {termp ? 'No se encontraron encuestas que coincidan con la búsqueda' : 'No hay encuestas disponibles'}
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         rowsPerPageOptions={[5, 10, 25, 50]}
//         component="div"
//         count={encuestasFiltradas.length}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//         labelRowsPerPage="Filas por página:"
//         labelDisplayedRows={({ from, to, count }) =>
//           `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
//         }
//       />
//     </Paper>
//   );
// };

// export default TEncuestas;

import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import { 
  Edit,
  Visibility,
  Delete,
  Assignment
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { eliminarEncuesta } from '../../actions/EncuestaAction'; 

const TEncuestas = ({ rows, termp, onEncuestaEliminada }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [encuestaAEliminar, setEncuestaAEliminar] = useState(null);
  const [eliminando, setEliminando] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const history = useHistory();

  // Filtrar encuestas basado en el término de búsqueda
  const encuestasFiltradas = rows.filter((encuesta) => {
    if (!termp) return true;
    
    const searchTerm = termp.toLowerCase();
    return (
      encuesta.titulo?.toLowerCase().includes(searchTerm) ||
      encuesta.descripcion?.toLowerCase().includes(searchTerm) ||
      encuesta.numEncuesta?.toLowerCase().includes(searchTerm)
    );
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const handleVerEncuesta = (encuestaId) => {
    history.push(`/ver-encuesta/${encuestaId}`);
  };

  const handleEditarEncuesta = (encuestaId) => {
    console.log('Editar encuesta:', encuestaId);
    history.push(`/modificar-encuesta/${encuestaId}`);
  };

  const handleEliminarEncuesta = (encuesta) => {
    setEncuestaAEliminar(encuesta);
    setModalEliminar(true);
  };

  const confirmarEliminacion = async () => {
    if (!encuestaAEliminar) return;

    setEliminando(true);
    try {
      await eliminarEncuesta(encuestaAEliminar.encuestaId);
      
      // Mostrar mensaje de éxito
      setSnackbar({
        open: true,
        message: 'Encuesta eliminada exitosamente',
        severity: 'success'
      });

      // Cerrar modal
      setModalEliminar(false);
      setEncuestaAEliminar(null);

      // Callback para actualizar la lista (opcional)
      if (onEncuestaEliminada) {
        onEncuestaEliminada(encuestaAEliminar.encuestaId);
      }

    } catch (error) {
      console.error('Error al eliminar encuesta:', error);
      setSnackbar({
        open: true,
        message: 'Error al eliminar la encuesta. Inténtalo de nuevo.',
        severity: 'error'
      });
    } finally {
      setEliminando(false);
    }
  };

  const cancelarEliminacion = () => {
    setModalEliminar(false);
    setEncuestaAEliminar(null);
  };

  const handleGestionarRespuestas = (encuestaId) => {
    console.log('Gestionar respuestas:', encuestaId);
    history.push(`/respuestas/${encuestaId}`);
  };

  const cerrarSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Código Encuesta</strong></TableCell>
                <TableCell><strong>Título</strong></TableCell>
                <TableCell><strong>Descripción</strong></TableCell>
                <TableCell><strong>Fecha Creación</strong></TableCell>
                <TableCell><strong>Preguntas</strong></TableCell>
                <TableCell><strong>Acciones</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {encuestasFiltradas
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((encuesta) => (
                  <TableRow key={encuesta.encuestaId}>
                    <TableCell>{encuesta.numEncuesta}</TableCell>
                    <TableCell>{encuesta.titulo}</TableCell>
                    <TableCell>
                      {encuesta.descripcion && encuesta.descripcion.length > 50
                        ? `${encuesta.descripcion.substring(0, 50)}...`
                        : encuesta.descripcion}
                    </TableCell>
                    <TableCell>{formatearFecha(encuesta.fechaCreacion)}</TableCell>
                    <TableCell align="center">{encuesta.cantidadPreguntas}</TableCell>
                    <TableCell>
                      <Tooltip title="Ver encuesta">
                        <IconButton
                          color="primary"
                          onClick={() => handleVerEncuesta(encuesta.encuestaId)}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar encuesta">
                        <IconButton
                          color="default"
                          onClick={() => handleEditarEncuesta(encuesta.encuestaId)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver respuestas">
                        <IconButton
                          color="secondary"
                          onClick={() => handleGestionarRespuestas(encuesta.encuestaId)}
                        >
                          <Assignment />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Eliminar encuesta">
                        <IconButton
                          style={{ color: '#f44336' }}
                          onClick={() => handleEliminarEncuesta(encuesta)}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              {encuestasFiltradas.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {termp ? 'No se encontraron encuestas que coincidan con la búsqueda' : 'No hay encuestas disponibles'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={encuestasFiltradas.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
          }
        />
      </Paper>

      {/* Modal de confirmación para eliminar */}
      <Dialog
        open={modalEliminar}
        onClose={cancelarEliminacion}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar la encuesta "{encuestaAEliminar?.titulo}"?
            <br />
            <strong>Esta acción no se puede deshacer.</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={cancelarEliminacion}
            disabled={eliminando}
            color="inherit"
          >
            Cancelar
          </Button>
          <Button 
            onClick={confirmarEliminacion}
            color="error"
            variant="contained"
            disabled={eliminando}
            startIcon={eliminando ? <CircularProgress size={20} /> : <Delete />}
          >
            {eliminando ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para mostrar mensajes */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={cerrarSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={cerrarSnackbar} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TEncuestas;